/*
------------------------------------------------------------------------------------
ローカルストレージ内の保存用Objを初期化
------------------------------------------------------------------------------------
*/

function resetLsData(title, title_id) {
	return {
		title: title, // 書目タイトル名
		title_id: title_id, // 書目タイトルID
		current_head_id: 0, // 選択中の単元ID
		randomBool: false, // 現在のシャッフル出題論理値
		randomBool_before: null, // 前回解答時のシャッフル出題論理値（初回起動時の適用を防ぐため初期値はnullに）
		continueBool: false, // 「続きから解く」の論理値
		incorrectBool: false, // 「不正解の問題だけ解く」の論理値
		bookmarkBool: false, // 「登録した問題を解く」の論理値
		saveAry: [], // 成績データObj配列
	};
}
export default {resetLsData}